function formSliderSurvey() {

    var sliderGroups = document.querySelectorAll('.form--slider__group');
    if (!sliderGroups.length) { return; }

    [].forEach.call(sliderGroups, function(sliderGroup) {

        var slider = {};
        slider.label = sliderGroup.querySelector('.form--slider__label');
        slider.input = sliderGroup.querySelector('.form--slider__survey');
        slider.value = slider.input.value;
        slider.min = slider.input.min;
        slider.max = slider.input.max;
        slider.percentage = ((slider.value - slider.min) * 100) / (slider.max - slider.min);

        slider.label.style.left = slider.percentage + '%';
        slider.label.innerText = slider.value;

        slider.input.addEventListener('change', function(){

            slider.value = slider.input.value;
            slider.percentage = ((slider.value - slider.min) * 100) / (slider.max - slider.min);

            slider.label.style.left = slider.percentage + '%';
            slider.label.innerText = slider.value;

        }, false);

    });

}

formSliderSurvey();
